/**
 * 261018 대표 주차판 시연(10/16 17:14) — 앱이 '맡긴 QR'을 되찾아 주차판 등록 화면을 연 지 2초 만에
 * 이미 지운 업체 상세(빈 화면에 '영업시간')로 튕겼다.
 *
 * 원인은 안드로이드 MainActivity — 푸시를 눌러 켠 앱은 그 인텐트(callbackName·callbackParams)를 지우지 않는다.
 * 앱이 백그라운드에서 꺼졌다가(메모리 회수) 다시 만들어지면 같은 인텐트로 onCreate 가 돌고, checkMoveLink 가
 * 그 옛 푸시 이동(fnRouterPush)을 다시 쏜다. 대표님 폰은 그날 '신규 가게 입점'(업체 186) 푸시로 켠 앱이었다.
 * 네이티브 수정은 앱 업데이트가 있어야 나간다. 그 전에 웹에서 가를 수 있는 건 이 경우다:
 * 방금 맡긴 QR 로 화면을 열었다면 그 사람은 QR 때문에 앱을 연 것이다 — 그 직후 몇 초 안에 오는 푸시 이동은 되살아난 옛 알림이다.
 * (그 몇 초 사이에 새 알림을 눌러 들어오는 일은 사실상 없다.)
 */
const GUARD_MS = 10000;
let resumedAt = 0;

/** App.vue#resumePendingQrClaim 이 QR 화면으로 보내기 직전에 부른다. */
export const markQrResumeNavigated = () => {
  resumedAt = Date.now();
};

/** NativeCall.js#fnRouterPush — 참이면 그 푸시 이동을 버린다. */
export const isJustAfterQrResume = () => resumedAt > 0 && Date.now() - resumedAt < GUARD_MS;
